// extracted by mini-css-extract-plugin
export default {"errorLoading":"Invoicing_errorLoading__Snx9P","root":"Invoicing_root__kcXTv","breadcrumb":"Invoicing_breadcrumb__U5tA0"};